var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.025 5.4L6.97502 5.4C6.10686 5.4 5.40002 6.10684 5.40002 6.975L5.40002 15.025C5.40002 15.8932 6.10686 16.6 6.97502 16.6H11.7C11.9899 16.6 12.225 16.3648 12.225 16.075C12.225 15.7852 11.9899 15.55 11.7 15.55H6.97502C6.68586 15.55 6.45002 15.3142 6.45002 15.025L6.45002 6.975C6.45002 6.68583 6.68586 6.45 6.97502 6.45L15.025 6.45C15.3142 6.45 15.55 6.68583 15.55 6.975L15.55 11.7C15.55 11.9898 15.7852 12.225 16.075 12.225C16.3649 12.225 16.6 11.9898 16.6 11.7V6.975C16.6 6.10684 15.8932 5.4 15.025 5.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.075 16.6H13.8C13.5102 16.6 13.275 16.3648 13.275 16.075C13.275 15.7852 13.5102 15.55 13.8 15.55H14.8076L11.6788 12.4212C11.4738 12.2161 11.4738 11.8839 11.6788 11.6788C11.7814 11.5763 11.9154 11.525 12.05 11.525C12.1847 11.525 12.3187 11.5763 12.4212 11.6788L15.55 14.8076V13.8C15.55 13.5102 15.7852 13.275 16.075 13.275C16.3649 13.275 16.6 13.5102 16.6 13.8V16.075C16.6 16.3648 16.3649 16.6 16.075 16.6Z",
    fill: "#0265DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.575 6.80001C12.8649 6.80001 13.1 7.03506 13.1 7.32501C13.1 7.61496 12.8649 7.85001 12.575 7.85001C12.285 7.85001 12.05 7.61496 12.05 7.32501C12.05 7.03506 12.285 6.80001 12.575 6.80001Z",
    fill: "#292929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.575 8.375C12.8649 8.375 13.1 8.61005 13.1 8.9C13.1 9.18995 12.8649 9.425 12.575 9.425C12.285 9.425 12.05 9.18995 12.05 8.9C12.05 8.61005 12.285 8.375 12.575 8.375Z",
    fill: "#292929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.575 9.95C12.8649 9.95 13.1 10.1851 13.1 10.475C13.1 10.7649 12.8649 11 12.575 11C12.285 11 12.05 10.7649 12.05 10.475C12.05 10.1851 12.285 9.95 12.575 9.95Z",
    fill: "#292929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32499 12.05C7.61494 12.05 7.84999 12.285 7.84999 12.575C7.84999 12.8649 7.61494 13.1 7.32499 13.1C7.03504 13.1 6.79999 12.8649 6.79999 12.575C6.79999 12.285 7.03504 12.05 7.32499 12.05Z",
    fill: "#292929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 12.05C9.18995 12.05 9.425 12.285 9.425 12.575C9.425 12.8649 9.18995 13.1 8.9 13.1C8.61005 13.1 8.375 12.8649 8.375 12.575C8.375 12.285 8.61005 12.05 8.9 12.05Z",
    fill: "#292929"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.475 12.05C10.765 12.05 11 12.285 11 12.575C11 12.8649 10.765 13.1 10.475 13.1C10.1851 13.1 9.95001 12.8649 9.95001 12.575C9.95001 12.285 10.1851 12.05 10.475 12.05Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/collapse-all.2e9050dbd2ea8c4c754f0c9c33711e49.svg";
export { ForwardRef as ReactComponent };